import './Divider.scss';

export const Divider = ({ classNames }: { classNames: string }) => {
    return (
//        <div className={`relative w-full border-b border-[10px] primary-color-border ${classNames}`}></div>
        <div className={`relative w-full border-b border-gray-300 ${classNames}`}></div>
    )
}